/**
 * Righe di un carrello abbandonato (risposta di POST ai/cart), pronte da mostrare.
 *
 * Il backend restituisce due array allineati per indice: `items[i]` e' quello che il
 * cliente ha messo nel carrello ({ items: ProductId, variants: variante, qt }) e
 * `data[i]` il prodotto letto dal catalogo. Il carrello non salva il prezzo del momento:
 * `prezzo` e' il prezzo di listino attuale della variante (pricevat), quindi una stima.
 */
export function righeCarrello(carrello, variantiSetting) {
	const lang = carrello && carrello.lang;
	const righe = (carrello && carrello.items) || [];
	const prodotti = (carrello && carrello.data) || [];

	return righe.map((riga, i) => {
		const prodotto = prodotti[i] || {};
		const idVariante = riga.variants ? riga.variants.toString() : '';
		const variante = (prodotto.variants || []).find(v => v._id && v._id.toString() === idVariante) || null;
		const qt = Number(riga.qt) || 0;
		const prezzo = variante ? Number(variante.pricevat || variante.sell) : NaN;

		return {
			key: `${riga.items}-${idVariante}-${i}`,
			nome: nomeProdotto(prodotto, lang),
			sku: (variante && variante.sku) || '',
			variante: nomeVariante(variante, variantiSetting, lang),
			qt,
			prezzo: isNaN(prezzo) ? null : prezzo,
			totale: isNaN(prezzo) ? null : prezzo * qt,
			immagine: immagineVariante(prodotto, idVariante),
		};
	});
}

/** Pezzi e valore stimato del carrello; il valore e' null se nessuna riga ha un prezzo. */
export function riepilogoCarrello(righe) {
	const pezzi = righe.reduce((n, r) => n + r.qt, 0);
	const conPrezzo = righe.filter(r => r.totale !== null);
	const valore = conPrezzo.length ? conPrezzo.reduce((n, r) => n + r.totale, 0) : null;
	return { pezzi, valore };
}

export function euro(valore) {
	const n = Number(valore);
	return valore === null || valore === undefined || isNaN(n) ? '—' : `${n.toFixed(2).replace('.', ',')} €`;
}

function nomeProdotto(prodotto, lang) {
	const trans = prodotto.trans || [];
	const t = trans.find(el => el.lang === lang) || trans[0];
	return (t && t.name) || 'Prodotto non più a catalogo';
}

// "Taglia: M / Colore: Rosso" dai nomi configurati nelle impostazioni
function nomeVariante(variante, variantiSetting, lang) {
	if (!variante || !(variante.variants || []).length) return '';
	return variante.variants
		.map(v => {
			const nome = (variantiSetting || []).find(el => el._id && el._id.toString() === String(v.name));
			if (!nome) return '';
			const valore = (nome.values || []).find(el => el._id && el._id.toString() === String(v.value));
			const t = (lista, campo) => {
				const tr = (lista || []).find(el => el.lang === lang) || (lista || [])[0];
				return tr ? tr[campo] : '';
			};
			const testoNome = t(nome.trans, 'name');
			const testoValore = valore ? t(valore.trans, 'name') : '';
			return [testoNome, testoValore].filter(Boolean).join(': ');
		})
		.filter(Boolean)
		.join(' / ');
}

// immagine della variante nel carrello, altrimenti la principale del prodotto
function immagineVariante(prodotto, idVariante) {
	const immagini = prodotto.images || [];
	const diVariante = idVariante ? immagini.find(img => (img.variants || []).some(v => v && v.toString() === idVariante)) : null;
	const img = diVariante || immagini[0];
	return (img && img.sizes && img.sizes[0] && img.sizes[0].value) || null;
}
